"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepIssueEnum = exports.StepIntegrationIssueEnum = exports.StepContentIssueEnum = void 0;
var StepContentIssueEnum;
(function (StepContentIssueEnum) {
    StepContentIssueEnum["ILLEGAL_VARIABLE_IN_CONTROL_VALUE"] = "ILLEGAL_VARIABLE_IN_CONTROL_VALUE";
    StepContentIssueEnum["MISSING_VALUE"] = "MISSING_VALUE";
    StepContentIssueEnum["TIER_LIMIT_EXCEEDED"] = "TIER_LIMIT_EXCEEDED";
})(StepContentIssueEnum || (exports.StepContentIssueEnum = StepContentIssueEnum = {}));
var StepIntegrationIssueEnum;
(function (StepIntegrationIssueEnum) {
    StepIntegrationIssueEnum["MISSING_INTEGRATION"] = "MISSING_INTEGRATION";
})(StepIntegrationIssueEnum || (exports.StepIntegrationIssueEnum = StepIntegrationIssueEnum = {}));
var StepIssueEnum;
(function (StepIssueEnum) {
    StepIssueEnum["ILLEGAL_VARIABLE_IN_CONTROL_VALUE"] = "ILLEGAL_VARIABLE_IN_CONTROL_VALUE";
    StepIssueEnum["MISSING_VALUE"] = "MISSING_VALUE";
    StepIssueEnum["TIER_LIMIT_EXCEEDED"] = "TIER_LIMIT_EXCEEDED";
    StepIssueEnum["MISSING_INTEGRATION"] = "MISSING_INTEGRATION";
})(StepIssueEnum || (exports.StepIssueEnum = StepIssueEnum = {}));
//# sourceMappingURL=step-content-issue.enum.js.map